import { __makeTemplateObject } from "tslib";
import React, { useEffect, useRef, useState } from "react";
import IntlTelInput from "react-intl-tel-input-18";
import "react-intl-tel-input-18/dist/main.css";
import styled from "@emotion/styled";
import { getExample, parsePhoneNumber, getCountryCodeForRegionCode, } from "awesome-phonenumber";
var getCleanNumber = function (value) {
    return value.replace(/\D/g, "");
};
function formatNumberWithMask(inputNumber, mask, limitToMasked) {
    if (limitToMasked === void 0) { limitToMasked = true; }
    var cleanNumber = getCleanNumber(inputNumber);
    var cleanNumberIndex = 0;
    var masked = mask.split("").reduce(function (acc, curr) {
        if (cleanNumberIndex >= cleanNumber.length) {
            return acc;
        }
        if (curr === "x") {
            var number = cleanNumber[cleanNumberIndex++];
            return "".concat(acc).concat(number);
        }
        return "".concat(acc).concat(curr);
    }, "");
    var restOfCleanNumber = cleanNumber.substring(cleanNumberIndex);
    return limitToMasked ? masked : masked + restOfCleanNumber;
}
var getMaskFromRegion = function (regionCode) {
    var _a;
    var formated = (_a = getExample(regionCode, "mobile").number) === null || _a === void 0 ? void 0 : _a.national;
    if (!formated) {
        return "xxx xxx xxxx";
    }
    return formated.replace(/[0-9]/g, "x");
};
var formatNumber = function (value, regionCode) {
    var mask = getMaskFromRegion(regionCode);
    var cleanNumber = getCleanNumber(value);
    var maskValue = cleanNumber[0] !== "0" && regionCode.toLowerCase() === "hr" ? mask.substring(1) : mask;
    return formatNumberWithMask(value, maskValue);
};
var Label = styled.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  vertical-align: top;\n  font-style: normal;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.25;\n  color: #323232;\n  margin-bottom: 4px;\n"], ["\n  display: inline-block;\n  vertical-align: top;\n  font-style: normal;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.25;\n  color: #323232;\n  margin-bottom: 4px;\n"])));
var InvalidFeedback = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: #F6898A;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.14;\n  margin-bottom: 0;\n  padding-top: 4px;\n  transition: all 0.4s ease;\n"], ["\n  color: #F6898A;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.14;\n  margin-bottom: 0;\n  padding-top: 4px;\n  transition: all 0.4s ease;\n"])));
var FormHint = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: #999;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.14;\n  margin-bottom: 0;\n  padding-top: 4px;\n  transition: all 0.4s ease;\n"], ["\n  color: #999;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.14;\n  margin-bottom: 0;\n  padding-top: 4px;\n  transition: all 0.4s ease;\n"])));
var Container = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-bottom: 20px;\n\n  .intl-tel-input.allow-dropdown.separate-dial-code {\n    width: 100%;\n    color: #323232;\n\n    .flag-container {\n      &:hover .selected-flag {\n        background-color: rgba(0, 0, 0, 0.05);\n      }\n\n      .selected-flag {\n        z-index: 1;\n        position: relative;\n        display: flex;\n        height: 100%;\n        padding: 0 6px 0 12px;\n        width: fit-content;\n        background: none;\n        border-right: 1px solid #EDEDED;\n      }\n\n      .selected-dial-code {\n        padding: 0;\n        margin-left: 6px;\n        font-family: \"Red Hat Display\", sans-serif;\n        font-size: 18px;\n        font-weight: 400;\n        line-height: 24px;\n      }\n\n      .country-list {\n        z-index: 5;\n      }\n    }\n\n    input {\n      box-sizing: border-box;\n      display: block;\n      width: 100%;\n      height: 44px;\n      padding: 9px 12px;\n      padding-right: 12px !important;\n      padding-left: 107px !important;\n      font-family: \"Red Hat Display\", sans-serif;\n      font-size: 18px;\n      font-weight: 400;\n      font-style: normal;\n      line-height: 24px;\n      color: #4D4D4D;\n      outline: none;\n      background-color: #FFF;\n      border-radius: 8px;\n      border: 1px solid;\n      border-color: ", ";\n      transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n  \n      &:focus {\n        border-color: #666;\n      }\n  \n      &[disabled] {\n        opacity: 0.5;\n        pointer-events: none;\n      }\n    }\n  }\n"], ["\n  margin-bottom: 20px;\n\n  .intl-tel-input.allow-dropdown.separate-dial-code {\n    width: 100%;\n    color: #323232;\n\n    .flag-container {\n      &:hover .selected-flag {\n        background-color: rgba(0, 0, 0, 0.05);\n      }\n\n      .selected-flag {\n        z-index: 1;\n        position: relative;\n        display: flex;\n        height: 100%;\n        padding: 0 6px 0 12px;\n        width: fit-content;\n        background: none;\n        border-right: 1px solid #EDEDED;\n      }\n\n      .selected-dial-code {\n        padding: 0;\n        margin-left: 6px;\n        font-family: \"Red Hat Display\", sans-serif;\n        font-size: 18px;\n        font-weight: 400;\n        line-height: 24px;\n      }\n\n      .country-list {\n        z-index: 5;\n      }\n    }\n\n    input {\n      box-sizing: border-box;\n      display: block;\n      width: 100%;\n      height: 44px;\n      padding: 9px 12px;\n      padding-right: 12px !important;\n      padding-left: 107px !important;\n      font-family: \"Red Hat Display\", sans-serif;\n      font-size: 18px;\n      font-weight: 400;\n      font-style: normal;\n      line-height: 24px;\n      color: #4D4D4D;\n      outline: none;\n      background-color: #FFF;\n      border-radius: 8px;\n      border: 1px solid;\n      border-color: ", ";\n      transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n  \n      &:focus {\n        border-color: #666;\n      }\n  \n      &[disabled] {\n        opacity: 0.5;\n        pointer-events: none;\n      }\n    }\n  }\n"])), function (_a) {
    var errorState = _a.errorState;
    return (errorState ? "#F6898A" : "#999");
});
export var isNumberValid = function (value, regionCode) {
    try {
        return parsePhoneNumber(value, { regionCode: regionCode }).valid;
    }
    catch (_) {
        return false;
    }
};
export var getRegionCodeAndNumber = function (value, currentRegionCode) {
    var startsWithPlus = value[0] === "+";
    if (!startsWithPlus) {
        return { region: currentRegionCode, number: getCleanNumber(value) };
    }
    try {
        var parsed = parsePhoneNumber(value);
        var regionCode = parsed.regionCode || currentRegionCode;
        var countryCode = getCountryCodeForRegionCode(regionCode);
        var number = getCleanNumber(value.replace(countryCode.toString(), ""));
        return {
            region: regionCode === "ZZ" ? currentRegionCode : regionCode,
            number: number.toString(),
        };
    }
    catch (_) {
        var regionCode = "+".concat(getCountryCodeForRegionCode(currentRegionCode));
        return {
            region: currentRegionCode,
            number: getCleanNumber(value.replace(regionCode, "")),
        };
    }
};
var DEFAULT_REGION_CODE = "hr";
var PhoneInput = function (_a) {
    var _b;
    var value = _a.value, onChange = _a.onChange, label = _a.label, error = _a.error, showError = _a.showError, hint = _a.hint, disabled = _a.disabled, required = _a.required;
    var _c = useState(""), rawNumber = _c[0], setRawNumber = _c[1];
    var _d = useState(DEFAULT_REGION_CODE), regionCode = _d[0], setRegionCode = _d[1];
    var _e = useState(false), focus = _e[0], setFocus = _e[1];
    var _f = useState(""), errorText = _f[0], setErrorText = _f[1];
    var _g = useState(false), errorState = _g[0], setErrorState = _g[1];
    useEffect(function () {
        if (!value) {
            return;
        }
        var _a = getRegionCodeAndNumber(value, regionCode), region = _a.region, number = _a.number;
        if (number !== rawNumber) {
            setRawNumber(number);
        }
        if (region !== regionCode) {
            setRegionCode(region);
        }
    }, [value]);
    var onFlagSelect = function (_, selectedCountryData) {
        setRegionCode(selectedCountryData.iso2 || DEFAULT_REGION_CODE);
        var newValue = "+".concat(selectedCountryData.dialCode).concat(rawNumber);
        if (newValue === value) {
            return;
        }
        setRawNumber("");
        var dialCode = selectedCountryData.dialCode || "";
        onChange && onChange("+".concat(dialCode), false);
    };
    var isNumeric = function (value) {
        return /\d/.test(value);
    };
    var inputRef = useRef(null);
    var componentRef = useRef(null);
    // synching internal flag with regionCode prop
    useEffect(function () {
        if (!componentRef.current) {
            return;
        }
        var setFlag = function (regionCode) {
            if (!componentRef.current) {
                return;
            }
            componentRef.current.setFlag(regionCode.toLowerCase());
        };
        var componentCode = componentRef.current.state.countryCode;
        if (componentCode.toLocaleLowerCase() !== regionCode.toLocaleLowerCase()) {
            setFlag(regionCode);
        }
    }, [(_b = componentRef.current) === null || _b === void 0 ? void 0 : _b.state.countryCode, regionCode]);
    // updating carret position after formating
    useEffect(function () {
        var _a;
        var selectionStart = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.selectionStart;
        if (!inputRef.current || !selectionStart) {
            return;
        }
        var formatedValue = formatNumber(rawNumber, regionCode);
        var newSelectionStart = getNewSelectionStart(selectionStart, formatedValue);
        if (newSelectionStart !== selectionStart) {
            inputRef.current.setSelectionRange(newSelectionStart, newSelectionStart);
        }
    }, [rawNumber]);
    var onRawInput = function (event) {
        var value = event.currentTarget.value;
        inputRef.current = event.currentTarget;
        var cleanNumber = getCleanNumber(formatNumber(value, regionCode));
        setRawNumber(cleanNumber);
        var countryCode = getCountryCodeForRegionCode(regionCode);
        var isValid = isNumberValid(cleanNumber, regionCode);
        setErrorState(!isValid);
        if (isValid) {
            setErrorText('');
        }
        else {
            setErrorText('Unesi ispravni broj telefona');
        }
        onChange && onChange("+".concat(countryCode).concat(cleanNumber), isValid);
    };
    var getNewSelectionStart = function (selectionStart, value) {
        var letterBefore = value[selectionStart - 1];
        var letterAfter = value[selectionStart];
        if (letterAfter === undefined ||
            letterBefore === undefined ||
            (isNumeric(letterBefore) && isNumeric(letterAfter))) {
            return selectionStart;
        }
        return getNewSelectionStart(selectionStart + 1, value);
    };
    return (React.createElement(Container, { errorState: !!errorState || !!showError },
        label ? React.createElement(Label, null, label) : null,
        React.createElement(IntlTelInput, { telInputProps: { onInput: onRawInput }, value: formatNumber(rawNumber, regionCode), containerClassName: "intl-tel-input", preferredCountries: ["hr", "si", "de", "it"], onPhoneNumberBlur: function () {
                setFocus(false);
                if (required && !rawNumber) {
                    setErrorState(true);
                    setErrorText(error || 'Unesi ispravni broj telefona');
                }
            }, onPhoneNumberFocus: function () { return setFocus(true); }, onSelectFlag: onFlagSelect, separateDialCode: true, ref: componentRef, disabled: disabled }),
        !errorState && !showError && hint ? React.createElement(FormHint, null, hint) : null,
        errorState ? React.createElement(InvalidFeedback, null, errorText) : null,
        !errorState && showError && error ? React.createElement(InvalidFeedback, null, error) : null));
};
export var getFullPhoneNumberFromInput = function (value) {
    var _a;
    var parsed = parsePhoneNumber(value);
    return ((_a = parsed.number) === null || _a === void 0 ? void 0 : _a.e164) || null;
};
export default PhoneInput;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=PhoneInput.js.map